import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from '../../styles.module.scss';
import cn from 'classnames';

type Props = {
    active?: boolean;
    handleToggle?: () => void;
    className?: string;
};

export const MenuSport: React.FC<Props> = ({ active, handleToggle, className }) => (
    <div className={cn(className, styles.tooltipContent)}>
        <Link className={styles['navbar-item']} to="/players" onClick={active ? handleToggle : undefined}>
            <Trans i18nKey="menuPlayers" />
        </Link>
        <Link className={styles['navbar-item']} to="/tournaments" onClick={active ? handleToggle : undefined}>
            <Trans i18nKey="menuTournaments" />
        </Link>
        <Link className={styles['navbar-item']} to="/statistics" onClick={active ? handleToggle : undefined}>
            <Trans i18nKey="menuStatistics" />
        </Link>
    </div>
);
